const escape = s => s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");

export default escape;



// WEBPACK FOOTER //
// ./src/utils/escape-regex.js